import './style.scss';
import {
  Button, Popconfirm, notification, Alert, Input,
} from 'antd';
import H3FormInput from '@Uilib/h3FormInput';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import H3Text from '@Uilib/h3Text';
import EinvoiceEwaybillIntegrationActions from '@Actions/integrations/einvoiceEwaybillActions';
import UserActions from '@Actions/userActions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink } from '@fortawesome/free-solid-svg-icons';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';

const EwaybillLogin = ({
  user, GSTAuthentication, GSTAuthenticationLoading, enableEinvoiceEwaybillLoading, getUserProfile, GSTDeauthenticationLoading, GSTDeauthentication,
}) => {
  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [formSubmitted, setFormSubmitted] = useState(false);

  const apiCall = () => {
    setFormSubmitted(true);
    if (userName !== '' && password !== '') {
      const payload = {
        gstin: user.user_tenants.find((tenant) => tenant.tenant_id === user.tenant_info.tenant_id)?.gst_number,
        username: userName,
        password,
        tenant_id: user?.tenant_info?.tenant_id,
        is_e_way_bill_enabled: true,
      };
      GSTAuthentication(payload, () => { getUserProfile(); });
    } else {
      notification.open({
        type: 'error',
        message: 'Please provide a valid username and password.',
        duration: 4,
        placement: 'top',
      });
    }
  };

  const apiCallDeauthentication = () => {
    const payload = {
      gstin: user?.tenant_info?.gst_number,
      tenant_id: user?.tenant_info?.tenant_id,
    };
    GSTDeauthentication(payload, () => { getUserProfile(); });
  };
  return (
    <div className="gst-login__wrapper">
      <div>
        <div className="header-text">
          Authenticate Invoice Registration Portal(IRP)
        </div>
        <div className="gst-login__header">
          <div className="gst-login__header-icon">
            <FontAwesomeIcon icon={faLink} />
          </div>
          <H3Text
            text={(
              <div>
                Before you can connect Procuzy with e-Way Bill portal, you need the Username and Password generated by registering&nbsp;
                <a href="https://webtel.in/index.aspx" target="_blank" rel="noreferrer">Webtel Electrosoft Private Limited</a>
                &nbsp;
                as your GST Suvidha Provider in the e-Way Bill portal.
              </div>
            )}
            className="gst-login__header-text"
          />
        </div>
        <div className="login-wrapper">
          <p className="gst-input__label">
            GST Number
          </p>
          <H3FormInput
            name="GST Number"
            type="text"
            containerClassName="orgInputContainer "
            labelClassName="orgFormLabel"
            inputClassName="orgFormInput"
            placeholder="Username here.."
            disabled
            value={user?.tenant_info?.gst_number}
            maxlength="100"
          />
          <p className="gst-input__label">
            Username
            {' '}
            <span className="color-red">
              *
            </span>
            {' '}
          </p>
          <H3FormInput
            name="Username"
            type="text"
            containerClassName="orgInputContainer "
            labelClassName="orgFormLabel"
            inputClassName="orgFormInput"
            placeholder="Username here.."
            onChange={(value) => {
              setUserName(value.target.value);
            }}
            disabled={GSTAuthenticationLoading || enableEinvoiceEwaybillLoading || GSTDeauthenticationLoading}
            value={userName}
            maxlength="100"
            required
            showError={formSubmitted && userName === ''}
          />
          <p className="gst-input__label">
            Password
            {' '}
            <span className="color-red">
              *
            </span>
            {' '}
          </p>
          <div className="orgInputContainer">
            <Input.Password
              placeholder="input password"
              iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
              onChange={(value) => {
                setPassword(value.target.value);
              }}
              value={password}
              rootClassName="password-input"
              disabled={GSTAuthenticationLoading || enableEinvoiceEwaybillLoading || GSTDeauthenticationLoading}
            />
            {formSubmitted && !password && (
              <div className="input-error">
                *Please enter password
              </div>
            )}
          </div>
          <Alert
            type="info"
            message="Once Procuzy is connected with the IRP, any user with e-Invoicing permission can perform actions related to e-Invoicing."
            showIcon
            className="gst-login__warning"
          />
          <div className="button-wrapper">
            <H3Button
              text="Save & Validate "
              buttonType={defaultButtonTypes.BLUE_ROUNDED}
              customClass="gst-submit"
              disabled={GSTAuthenticationLoading || enableEinvoiceEwaybillLoading || GSTDeauthenticationLoading}
              isLoading={GSTAuthenticationLoading || enableEinvoiceEwaybillLoading || GSTDeauthenticationLoading}
              onClick={() => {
                apiCall();
              }}
            />
            <Popconfirm
              placement="topRight"
              title="Are you sure you want to disconnect E-Way Bill portal?"
              onConfirm={() => {
                apiCallDeauthentication();
              }}
              okText="Yes"
              cancelText="No"
            >
              {' '}
              <Button
                className="gst-cancel"
                disabled={GSTAuthenticationLoading || enableEinvoiceEwaybillLoading || GSTDeauthenticationLoading}
              >
                Cancel Registration
              </Button>

            </Popconfirm>

          </div>
        </div>

      </div>
    </div>
  );
};

const mapStateToProps = ({ EinvoiceEwaybillReducers }) => ({
  enableEinvoiceEwaybillLoading: EinvoiceEwaybillReducers.enableEinvoiceEwaybillLoading,
  GSTAuthenticationLoading: EinvoiceEwaybillReducers.GSTAuthenticationLoading,
});

const mapDispatchToProps = (dispatch) => ({
  enableEinvoiceEwaybill: (payload, callback) => dispatch(EinvoiceEwaybillIntegrationActions.enableEinvoiceEwaybill(payload, callback)),
  GSTAuthentication: (payload, callback) => dispatch(EinvoiceEwaybillIntegrationActions.GSTAuthentication(payload, callback)),
  getUserProfile: () => dispatch(UserActions.getUserProfile()),
  GSTDeauthentication: (payload, callback) => dispatch(EinvoiceEwaybillIntegrationActions.GSTDeauthentication(payload, callback)),
});

EwaybillLogin.propTypes = {
  user: PropTypes.any,
  GSTAuthentication: PropTypes.func,
  GSTDeauthentication: PropTypes.func,
  GSTDeauthenticationLoading: PropTypes.bool,
  enableEinvoiceEwaybillLoading: PropTypes.bool,
  GSTAuthenticationLoading: PropTypes.bool,
  enableEinvoiceEwaybill: PropTypes.func,
  getUserProfile: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(EwaybillLogin));
